var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRaza(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 533.2 226.7",
    style: {
      enableBackground: "new 0 0 533.2 226.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#CAAF92;} ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.6,206.9l-1.5,9.4h-2l4.4-26.5h2.8l4.6,26.5h-2l-1.6-9.4H6.6z M11.1,205.1c-1.1-6.8-1.9-11.4-2.1-13.6 H8.9c-0.1,2-1.1,8.1-2,13.6H11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.3,204.4c0-5.1,0.1-10.1,0.2-12.8h0c-0.7,4.3-3.1,16.7-4.7,24.7h-2c-1.2-6.8-3.7-20-4.4-24.7h-0.1 c0.1,3.1,0.2,9.1,0.2,13.6v11.1h-1.9v-26.5h2.9c1.7,8.6,4,19.8,4.3,23h0c0.4-3,2.8-14.9,4.6-23h2.9v26.5h-1.9V204.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.2,206.9l-1.5,9.4h-2l4.4-26.5H50l4.6,26.5h-2l-1.6-9.4H46.2z M50.7,205.1c-1.1-6.8-1.9-11.4-2.1-13.6 h-0.1c-0.1,2-1.1,8.1-2,13.6H50.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.2,216.3v-26.5h2.4c1.7,5.7,5.7,20.2,6.3,22.9h0.1c-0.1-3.8-0.2-7.5-0.2-11.8v-11.1h1.9v26.5h-2.4 c-1.8-6.2-5.8-20.9-6.5-23.7h0c0.2,3.2,0.3,7.9,0.3,12.7v11H61.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.8,191.6h-4.3v-1.8H88v1.8h-4.3v24.7h-1.9V191.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.8,203h-6v11.6h6.8l-0.3,1.8h-8.4v-26.5h8.3v1.8h-6.4v9.6h6V203z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.5,209.1v1.5c0,2.9,1,4.4,3.1,4.4c2.1,0,3.1-1.3,3.1-5c0-3.3-0.7-4.7-3.5-6.8c-2.8-2.2-4.2-3.5-4.2-7.4 c0-3.3,1-6.3,4.7-6.2c3.3,0,4.5,2.1,4.5,5.8v1.1h-1.9v-1c0-2.4-0.5-4.1-2.6-4.1c-2.2,0-2.7,1.9-2.7,4.2c0,2.9,0.6,3.8,3.1,5.8 c3.5,2.7,4.6,4.1,4.6,8.5c0,3.7-0.9,7-5,7c-3.8,0-5.1-2.6-5.1-6.1v-1.5H109.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M134.1,189.8h4.2c5.8,0,6.1,4,6.1,7.7v10.7c0,4.1-0.6,8.1-6.4,8.1h-3.9V189.8z M136,214.6h1.8 c3.6,0,4.6-1.9,4.6-5.8v-11.6c0-3.5-0.6-5.6-4.5-5.6H136V214.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M159.9,203h-6v11.6h6.8l-0.3,1.8h-8.4v-26.5h8.3v1.8h-6.4v9.6h6V203z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176.5,189.8h1.9v24.8h6.7l-0.3,1.8h-8.3V189.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M193,206.9l-1.5,9.4h-2l4.4-26.5h2.8l4.6,26.5h-2l-1.6-9.4H193z M197.4,205.1c-1.1-6.8-1.9-11.4-2.1-13.6 h-0.1c-0.1,2-1.1,8.1-2,13.6H197.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M217.4,189.8h4c3.8,0,5.2,2.2,5.2,5.6v1.3c0,3.7-1,4.9-2.5,5.4c1.6,0.4,3,1.9,3,5.3v1.9c0,4.7-1.4,7-5.9,7 h-3.9V189.8z M221.5,201.3c2.4,0,3.2-1.1,3.2-4.5v-1.3c0-2.5-1-4-3.5-4h-2v9.8H221.5z M219.3,214.6h1.9c3.2,0,4-1.6,4-5.3v-1.9 c0-3.1-1.3-4.4-3.8-4.4h-2.1V214.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M236.3,203.6v12.7h-1.9v-26.5h3.9c3.9,0,5.6,1.8,5.6,5.9v1.4c0,3.3-1,5.1-2.7,5.6c1.8,0.6,2.5,1.9,2.5,5.4 c0,2.3,0,6.5,0.3,8.2h-1.9c-0.3-1.7-0.3-6.2-0.3-8c0-3.6-0.5-4.7-3.3-4.7H236.3z M236.3,201.9h2.3c2.8,0,3.3-1.9,3.3-4.7v-1.4 c0-2.7-0.8-4.3-3.7-4.3h-1.9V201.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M253.2,206.9l-1.5,9.4h-2l4.4-26.5h2.8l4.6,26.5h-2l-1.6-9.4H253.2z M257.7,205.1 c-1.1-6.8-1.9-11.4-2.1-13.6h-0.1c-0.1,2-1.1,8.1-2,13.6H257.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M268.6,209.1v1.5c0,2.9,1,4.4,3.1,4.4c2.1,0,3.1-1.3,3.1-5c0-3.3-0.7-4.7-3.5-6.8c-2.8-2.2-4.2-3.5-4.2-7.4 c0-3.3,1-6.3,4.7-6.2c3.3,0,4.5,2.1,4.5,5.8v1.1h-1.9v-1c0-2.4-0.5-4.1-2.6-4.1c-2.2,0-2.7,1.9-2.7,4.2c0,2.9,0.6,3.8,3.1,5.8 c3.5,2.7,4.6,4.1,4.6,8.5c0,3.7-0.9,7-5,7c-3.8,0-5.1-2.6-5.1-6.1v-1.5H268.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M285.7,206.9l-1.5,9.4h-2l4.4-26.5h2.8l4.6,26.5h-2l-1.6-9.4H285.7z M290.1,205.1 c-1.1-6.8-1.9-11.4-2.1-13.6h-0.1c-0.1,2-1.1,8.1-2,13.6H290.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74,135.7v-35.2c0-19.7-4.8-25.8-13.3-29.8c5.6-2.3,14.8-8,14.8-30.3V35c0-26.1-13-35-35.1-35H18.8H9.4H0 l9.4,9.4v126.2L0,145.1h9.4v0h22.4v0h9.4l-9.4-9.4V80.2H37c13,0,15.3,4.1,15.3,21.7v33.7l-9.4,9.4h9.4v0H74v0h9.4L74,135.7z M36.9,61.7h-5.1V18.5h6.3c12.7,0,15,6.8,15,18v5C53.1,57.3,48.8,61.7,36.9,61.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M229.8,136L208.6,9.3l9.3-9.3h-9.4H207h-8h-15.5h-8.1h-1.3h-9.4l9.3,9.3l-20.4,126.6l-9.2,9.2h7.7v0h22.8v0 h0.8h9.4l-9-9l3.9-29.8h22.3l4.3,29.6l-9.2,9.2h9.4h1.2v0h23.4v0h7.5L229.8,136z M182.7,85.7c2.9-21.4,7.3-52.5,7.9-64.4h0.8 c1.7,16.4,4.8,39.8,8.1,64.4H182.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M533.2,145.1l-9.1-9.1L502.9,9.3l9.3-9.3h-9.4h-1.4h-8h-15.5h-8.1h-1.3H459l9.3,9.3l-20.4,126.6l-9.2,9.2 h7.7v0h22.8v0h0.7h9.4l-9-9l3.9-29.8h22.3l4.3,29.6l-9.2,9.2h9.4h1.2v0h23.4v0H533.2z M477,85.7c2.9-21.4,7.3-52.5,7.9-64.4h0.8 c1.7,16.4,4.8,39.8,8.1,64.4H477z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "363.4,124.5 332.2,124.5 371.5,17.5 371.5,0 319.4,0 309.9,0 309.9,20.8 309.9,30.2 319.3,20.8 346.9,20.8 306.3,130.3 306.3,145.1 370,145.1 370,145.1 372.8,145.1 372.8,115.1 363.4,124.5 "
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaza);
export default __webpack_public_path__ + "static/media/raza.be8faaba3a7eda8e9b86c524684b478f.svg";
export { ForwardRef as ReactComponent };